import React, { useCallback, useRef, useState } from "react"

import { RiArrowDropDownLine, RiArrowDropRightLine, RiCheckDoubleFill } from "react-icons/ri"
import { MdOutlineModeEdit } from "react-icons/md"
import { Config, NoPhoto, BarGraph, Question, FolderPlus, Company } from "../ImageComponents"
import { ButtonActions, UploadButton } from "../Button"
import Badge from "../Badge"
import { VariableSizeList as List } from "react-window"
import { ImArrowDown, ImArrowUp } from "react-icons/im"
import {
  SelectInput,
  Input,
  InputMetricText,
  TextArea,
  Label,
  NumberInputCount,
} from "../Form"
import { Column } from "../Layout"
import "./styles.scss"

export const CardAlign = ({ children, align = "right" }) => {
  return <div className={`card-container--${align}`}>{children}</div>
}

export const CardCompany = ({ companyImage, companyData, navigate }) => {
  const handleLinkToDash = () => { }

  return (
    <div
      className="card-company"
      style={{ backgroundImage: `url(${companyImage})` }}
      onClick={(e) => handleLinkToDash(e)}>
      <div className="card-company__content">
        <div className="card-company__content--top">
          {!companyData.image && <h2>{companyData.name}</h2>}
          <button
            onClick={() => navigate(`/companies/${companyData.id}`)}
            className="config-button">
            <Config />
          </button>
        </div>
        <div className="card-company__content--bottom">
          {companyData.data &&
            companyData.data.map((cardsInfo, index) => (
              <div key={index} className="card-company__content--bottom__info one">
                <span className="card-company__content--bottom__info-qtd">
                  {cardsInfo.quantity || 0}
                </span>
                <span className="card-company__content--bottom__info-desc project">
                  {cardsInfo.description}
                </span>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export const CardImageCompany = ({ companyImage }) => {
  let image = { background: "none" }
  if (companyImage) {
    image = { backgroundImage: `url(${companyImage})`, border: "1.5px solid #efefefcc" }
  }
  return (
    <div className="card-image-company" style={image}>
      {!companyImage && (
        <div className="card-image-company__nophoto">
          <NoPhoto />
        </div>
      )}
    </div>
  )
}

export const CardDouble = ({ children }) => {
  return <div className="card-double">{children}</div>
}

export const CardDoubleSide = ({
  title,
  header,
  col,
  className,
  position = "",
  children,
  scroll = "",
}) => {
  return (
    <Column col={col} className={className}>
      <div className={`card-double--${position}`}>
        <h2 className="card-double__header">
          {header}
          {title}
        </h2>
        <div className={`card-double__content ${scroll && "scroll"}`}>{children}</div>
      </div>
    </Column>
  )
}

export const CardSingle = ({ children, title, scroll }) => {
  return (
    <div className="card-single">
      <div className="card-single__wrapper">
        <h2 className="card-single__wrapper__header">{title}</h2>
        <div className={`card-single__content ${scroll ? "scroll" : ""}`}>{children}</div>
      </div>
    </div>
  )
}

export const Card = ({ children, className, style, onClick, ...props }) => {
  return (
    <div
      onClick={onClick}
      {...props}
      style={style}
      className={`card${className ? " " + className : ""}`}>
      {children}
    </div>
  )
}

export const CardModal = ({ children, className, noPadding }) => {
  return (
    <div
      className={`card-modal${className ? " " + className : ""}`}
      style={noPadding && { padding: 0 }}>
      {children}
    </div>
  )
}

export const CardBody = ({ children }) => {
  return <div className="card-content">{children}</div>
}

export const CardTitle = ({ title, children, className, style }) => {
  return (
    <div style={style} className={`card-title${className ? " " + className : ""}`}>
      {title}
      {children && <div className="card-title-content">{children}</div>}
    </div>
  )
}

export const CardTitleWithContent = ({ title, children, styles, className }) => {
  return (
    <div style={styles} className={`card-title${className ? " " + className : ""} ${children ? " " + "card-title-content" : ""}`}>
      {title}
      {children && <div className="card-title-content">{children}</div>}
    </div>
  )
}

export const CardPhoto = ({ children, image, isWhite, onChangeImage }) => {
  const color = isWhite && "white"
  let imageBg = { background: "none" }
  if (image) {
    imageBg = { backgroundImage: `url(${image})`, border: "1.5px solid #efefefcc" }
  }

  return (
    <div className="card-photo" style={imageBg}>
      {!image && (
        <div className={`card-photo--${color || "secondary"}`}>
          <div className="card-photo__content">
            <div className="no-photo-icon">
              <NoPhoto />
            </div>
            <div className="card-photo__info-button">
              <span>{children}</span>
              <UploadButton
                label={"Importar"}
                color={color}
                onFileChange={onChangeImage}
                name="picture"
                accept="image/png"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export const CardDefault = ({
  color,
  label,
  children,
  handleClick,
  noDisplayFlex,
  noFlexWrap,
  image,
  hasIcon,
  squareImage,
  description,
  hasValue,
  year,
  hasCheckInImage
}) => {
  const displayFlex = noDisplayFlex && "initial"
  const flexWrap = noFlexWrap && "nowrap"
  const imageShape = squareImage ? "square" : "rounded"

  return (
    <div className={`card-default card-default--${color || "primary"}`} onClick={handleClick}>
      <div className="card-default__content" style={{ display: displayFlex, flexWrap: flexWrap }}>
        <div className="image-flex-c">
          {(image) && (
            <img
              className={`card-default__image card-default__image--${imageShape}`}
              src={image}></img>
          )}
          {hasIcon && !image && (
            <img
              className={`card-default__image card-default__image--${imageShape}`}
              src={hasIcon}
              style={{ objectFit: "none" }}></img>
          )}
          {(!hasValue) && <Badge color={"primary"} label={"Em breve"} />}
        </div>
        <div className="text-container">
          {label && <span className="text"><b>{year}</b>{` ${label}`}</span>}
          {description && <span className="text sub-text">{description}</span>}
        </div>
        {hasCheckInImage && <div className='icon-container'><RiCheckDoubleFill/></div>}
        {children}
      </div>
    </div>
  )
}

export const CardIndicator = ({
  classification,
  typeIndicator,
  nameIndicator,
  image,
  children,
  navigate,
}) => {
  return (
    <div
      style={{ display: "flex", cursor: "pointer" }}
      onClick={navigate && (() => navigate("/indicators/information"))}
      className="card-indicator-btn">
      <div className="card-indicator-btn__content">
        <div className="card-indicator-btn__content-header">
          {image && <img className="card-indicator-btn__content-header-image" src={image} alt="" />}
          {!image && (
            <div className="card-indicator-btn__content-header-image">
              <Company />
            </div>
          )}
          <div className="card-indicator-btn__content-header-type">
            <div className="indicator-type">{typeIndicator}</div>
            <Badge color={classification !== "Principal" && "secondary"} label={classification} />
          </div>
        </div>
        <div className="card-indicator-btn__content-header-name">{nameIndicator}</div>
      </div>
      {children}
    </div>
  )
}

export const AccordionItemContainer = ({
  typeButton,
  hasButton,
  children,
  handleClick,
  showOverlay,
}) => {
  return (
    <>
      <div className={`${showOverlay && "opacityBG"}`}></div>
      <div className={`accordion-card-item`}>
        {children}
        {hasButton &&
          (typeButton === "edit" ? (
            <ButtonActions type={typeButton} handleClick={handleClick}>
              <div className={`${showOverlay && "opacityButton"}`}>
                <MdOutlineModeEdit />
              </div>
            </ButtonActions>
          ) : (
            <ButtonActions type={typeButton} handleClick={handleClick} />
          ))}
      </div>
    </>
  )
}

export const AccordionItem = ({ hasButton = false, typeButton, handleClick, content }) => {
  const contentEl = useRef(null)

  const [isActive, setActive] = useState("inactive")
  const [scrollHeight, setScrollHeight] = useState("0px")
  const [showOverlay, toggleOverlay] = useState(false)

  const onToggle = () => {
    setActive(isActive === "inactive" ? "active" : "inactive")
    setScrollHeight(isActive === "active" ? "0px" : `${contentEl.current.scrollHeight}px`)
    isActive && toggleOverlay(!showOverlay)
  }

  const { type, code, title } = content

  return (
    <AccordionItemContainer
      hasButton={hasButton}
      typeButton={typeButton}
      handleClick={handleClick}
      showOverlay={showOverlay}>
      <div className={`accordion-card-item__content ${isActive}`}>
        <div className="accordion-toggle-header" onClick={onToggle}>
          <Badge
            label={code}
            color={isActive === "active" ? "primary" : "secondary"}
            isOpacity={isActive === "active"}
            textColor={isActive === "active" ? "white" : "secondary"}
            isUpperCase
          />
          <div className={`accordion-toggle-header__title ${isActive === "active" && "white"}`}>
            {title || ""}
          </div>
          <span className="control">
            {isActive ? <RiArrowDropDownLine size={22} /> : <RiArrowDropRightLine size={22} />}{" "}
          </span>
        </div>
        <div
          ref={contentEl}
          className="accordion-card-item__content-fields"
          style={{ height: `${scrollHeight}` }}>
          <div className="accordion-card-item__content-fields__item">
            {type === "text" && <Input type={type} placeholder={"Digite aqui"} />}
            {type === "textarea" && (
              <TextArea
                resize={"none"}
                type={type}
                placeholder={"Digite aqui"}
                isDisabled
              />
            )}
            {type === "number" && <NumberInputCount value={"0"} isDisabled />}
            {type === "file" && <CardPhoto isWhite />}
            {type === "date" && (
              <Label col={5} noFocus>
                <Input type={type} />
              </Label>
            )}
            {type === "metric" && <InputMetricText isDisabled />}
            {type === "select" && <SelectInput />}
            {type === "tel" && (
              <Input type={type} placeholder={"Digite aqui o telefone"} isDisabled />
            )}
          </div>
        </div>
      </div>
    </AccordionItemContainer>
  )
}

export const AccordionCard = ({ data, hasButton, typeButton }) => {
  const getItemSize = (index) => index + 105

  const Row = useCallback(
    ({ index, style }) => {
      const content = data[index]
      return (
        <div style={style}>
          <AccordionItem
            key={index}
            content={content}
            hasButton={hasButton}
            typeButton={typeButton}
          />
        </div>
      )
    },
    [data],
  )

  return (
    <div className="accordion-card">
      <div className="accordion-card__list">
        <List
          className="hide-scrollbar"
          height={532}
          itemCount={data.length}
          itemSize={getItemSize}
          width={"100%"}>
          {Row}
        </List>
      </div>
    </div>
  )
}

export const NoItemCard = ({ label, size, typeIcon = "picture" }) => {
  return (
    <div className={`no-item no-item--${size}`}>
      {typeIcon === "picture" && <NoPhoto />}
      {typeIcon === "bar-graph" && <BarGraph />}
      {typeIcon === "question" && <Question />}
      {typeIcon === "project" && <FolderPlus />}
      <span className="no-item__label">{label}</span>
    </div>
  )
}

export const CardActions = ({
  color,
  label,
  children,
  handleClick,
  image,
  hasIcon = "",
  imageShape,
}) => {
  return (
    <div className={"card-actions"}>
      <div
        className={`card-actions__content card-actions__content--${color || "primary"}`}
        onClick={handleClick}>
        {image && <img className={`card-actions__content-image--${imageShape}`} src={image}></img>}
        {hasIcon && !image && (
          <img
            className={`card-actions__content-image--${imageShape}`}
            src={hasIcon}
            style={{ objectFit: "none" }}></img>
        )}
        {label && <span className="text">{label}</span>}
      </div>
      {children}
    </div>
  )
}

/////////////////////////////////////////////// NEW COMPONENTS ////////////////////////////////////////////

export const CardsInfoTitleSub = ({ title, subtitle, subPercent, onClick, className, ...props }) => {
  const hasClick = onClick ? " card-click-hover " : " "
  
  const subTitlePercent = subPercent < 0 ? subPercent : subPercent === 0 ? 0 : subPercent === title ? 100 : (props?.percent || 0);
  const arrowPercent = subPercent === title || props?.percent > 0 ? <ImArrowUp  size={12} className="card-icon card-icon--success" /> : <ImArrowDown size={12} className="card-icon card-icon--warning" />

  return (
    <Card className={`cards-info-title-content${hasClick}no-border ${className ? className : ""}`} {...props} onClick={onClick}>
      <div className="card-info-header-column">
        <span className="card-info-title">
          {title}
          {props?.hasPercent && (<span className={`card-info-title-percent ${props?.percent < 0 && 'warning'}`}>
            <span>{subTitlePercent}%</span>
            {arrowPercent}
            {subPercent && <span style={{marginLeft: "4px"}}>{`${subPercent}`}</span>}
          </span>)}
        </span>
        <span className="card-info-subtitle">
          {subtitle}
        </span>
      </div>
    </Card>
  )
}

export const PercentCell = ({ percent, subPercent, hasPercent, value }) => {
  const strValue = value || 0
  return <div title={`Valor de referência: ${subPercent}`} className={`card-info-title-percent ${percent < 0 ? 'warning' : percent > 0 || (hasPercent) ? 'success' : ''}`}>
    <span className="value-item">{strValue}</span>
  </div>
}

export const PercentCellRenderer = ({ hasPercent, info }) => {
  const { value } = info
  return <div className={`card-info-title-percent ${value < 0 ? 'warning' : value > 0 || (hasPercent) ? 'success' : ''}`}>
    <div className="vertical">
      {(value > 0 || value < 0) ? <div className="vertical-item">
        <span className="ind-item">{`${value || 100}%`}</span>
        {value > 0 && <ImArrowUp size={12} className="card-icon card-icon--success" />}
        {value < 0 && <ImArrowDown size={12} className="card-icon card-icon--warning" />}
      </div> : "0"}
    </div>
  </div>
}
